import { Globe, PhoneCall, Mail } from 'lucide-react';

const channels = [
  {
    icon: Globe,
    title: 'Web research',
    accent: 'from-rose-400 to-rose-600',
    desc:
      'Perplexity Sonar Pro for citations, spider.cloud for headless rendering and PDFs, Google Maps for geographic discovery, EDGAR + WHOIS + state filings for verification.',
    bullets: [
      'Cited answers, not vibes',
      'JS-rendered + PDF parsing',
      'Free public sources only',
    ],
  },
  {
    icon: PhoneCall,
    title: 'Voice research',
    accent: 'from-violet-400 to-violet-600',
    desc:
      'When the web has nothing, THEO calls the agency. Mandatory disclosure script, IVR navigation, recording with two-party-consent compliance, transcript-back.',
    bullets: [
      'AI identity disclosed',
      'Two-party-consent safe',
      'Optional per job',
    ],
  },
  {
    icon: Mail,
    title: 'Email research',
    accent: 'from-cyan-400 to-cyan-600',
    desc:
      'AWS SES outbound with reply-tracking. Email-pattern inference engine generates valid candidates from a single verified address. Bounces auto-flag the address as unverified.',
    bullets: [
      'Pattern inference built-in',
      'Reply intent extraction',
      'Optional per job',
    ],
  },
];

export default function ChannelsSection() {
  return (
    <section id="channels" className="relative bg-ink-950 py-24">
      <div className="mx-auto max-w-7xl px-6">
        <div className="mx-auto max-w-3xl text-center">
          <p className="mb-4 text-sm font-semibold uppercase tracking-wider text-rose-400">
            Three channels. One brief.
          </p>
          <h2 className="text-4xl font-bold tracking-tight text-white sm:text-5xl">
            Tell it what you need. <br className="hidden sm:block" />
            It picks how to find it.
          </h2>
          <p className="mx-auto mt-6 max-w-2xl text-lg text-slate-400">
            THEO routes each step to the cheapest, fastest channel that gets
            the answer with confidence — and escalates only when the prior
            tier comes up short.
          </p>
        </div>

        <div className="mt-16 grid gap-6 md:grid-cols-3">
          {channels.map((c) => {
            const Icon = c.icon;
            return (
              <div
                key={c.title}
                className="card-hover relative overflow-hidden rounded-2xl border border-white/10 bg-ink-900/60 p-8"
              >
                <div className={`absolute -right-16 -top-16 h-40 w-40 rounded-full bg-gradient-to-br ${c.accent} opacity-10 blur-3xl`} />
                <div className={`mb-6 inline-grid h-12 w-12 place-items-center rounded-xl bg-gradient-to-br ${c.accent}`}>
                  <Icon className="h-6 w-6 text-white" strokeWidth={2} />
                </div>
                <h3 className="mb-3 text-xl font-bold text-white">{c.title}</h3>
                <p className="mb-6 text-sm leading-relaxed text-slate-400">{c.desc}</p>
                <ul className="space-y-2 text-sm">
                  {c.bullets.map((b) => (
                    <li key={b} className="flex items-center gap-2 text-slate-300">
                      <span className="h-1 w-1 rounded-full bg-rose-400" />
                      {b}
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
